import { PROTECTED_PATHS } from "../../../app/constants";
import {
  errorNotifier,
  successNotifier,
} from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

// export const loginTenant = async (payload, setLoading, setIsLoggedin, setNextPage) => {
export const loginTenant = async (
  payload,
  setLoading,
  setIsLoggedin,
  setNextPage,
  setData
) => {
  try {
    const { MY_ESTATE } = PROTECTED_PATHS;
    setLoading(true);
    const {
      data: { result },
    } = await http.post(AUTH_ROUTES.LOGIN, payload);

    const token = result?.data?.userData?.token;
    const userId = result?.data?.userData?.userId;
    const tenantId = result?.data?.tenant?._id || userId;
    const reset = result?.data?.tenant?.resetPassword;
    const outstandingBalance = Number(result?.data?.tenant?.outstandingBalance || 0);
    const shouldRestrict = result?.data?.tenant?.shouldRestrict === true;

    if (!result.success) return { blocked: false };

    localStorage.setItem("userId", tenantId);

    if (outstandingBalance > 0 && shouldRestrict) {
      setLoading(false);
      setIsLoggedin(false);
      errorNotifier(`Your account is restricted due to an outstanding balance of ₦${outstandingBalance.toFixed(2)}.`);
      return {
        blocked: true,
        outstandingBalance,
        userId: tenantId,
        tenant: result?.data?.tenant || {},
      };
    }

    localStorage.setItem("11p221#", token);

    setData(result);
    setLoading(false);
    // setNextPage(true)

    if (reset) {
      setIsLoggedin(true);
      localStorage.setItem("userId", userId);
      // navigate('/home');
      successNotifier(result?.message);
      window.location.href = MY_ESTATE;
    } else {
      setNextPage(true);
    }
    // setIsLoggedin(true);
    localStorage.setItem("old", true);
    return { blocked: false };
  } catch (e) {
    console.log(e?.response?.data?.result?.message, "ERR2", e?.toJSON()?.message === "Network Error");
      setLoading(false);
  
    setIsLoggedin(false);
    const resultMessage = e?.response?.data?.result?.message;
    const message = e?.response?.data?.message;
    const errors = e?.response?.data?.errors;

    if (Array.isArray(errors)) {
      errorNotifier(errors.map((error) => error.msg).join(", "));
    } else if (errors?.data?.message || errors?.data?.result?.message) {
      errorNotifier(errors.data.message || errors.data.result.message);
    } else if (resultMessage || message) {
      errorNotifier(resultMessage || message);
    } else {
      errorNotifier("Please Check your network connection!!!");
    }
    return { blocked: false };
  }
};
